import { GridFields, HiddenBoxStyled } from 'components';
import { useField } from 'libs/form/fields/useField';
import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { Colors } from 'libs/ui/theme';
import {
  Field,
  useFormContext,
  TargetedFinancialInstrumentsFormType,
} from 'modules/client/legal/forms/targetedFinancialInstrumentsForm';

interface Props {
  type: keyof TargetedFinancialInstrumentsFormType['targetedFinancialInstruments']['financialInstruments'];
}

const Section = ({ type }: Props) => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const { field } = useField(
    `targetedFinancialInstruments.financialInstruments.${type}.enabled`
  );

  const editable = !readOnly;

  const enabled = !!field.value;

  if (!editable && !enabled) {
    return null;
  }

  return (
    <>
      <Stack alignItems="center" direction="row" spacing={12}>
        <Typography color={Colors.gray700} variant="bodyMedium">
          {t(
            `client.legal.targetedFinancialInstruments.financialInstruments.${type}.title`
          )}
        </Typography>
        {editable && (
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="space-between"
            spacing={8}
          >
            <Typography variant="caption">{t('common.choose')}</Typography>
            <Field.Switch
              name={`targetedFinancialInstruments.financialInstruments.${type}.enabled`}
            />
          </Stack>
        )}
      </Stack>

      <HiddenBoxStyled hidden={!enabled}>
        <GridFields>
          <Field.Price
            fullWidth
            label={t(
              `client.legal.targetedFinancialInstruments.financialInstruments.fields.monthlyTradeAmount.label`
            )}
            name={`targetedFinancialInstruments.financialInstruments.${type}.monthlyTradeAmount`}
            placeholder={t(
              `client.legal.targetedFinancialInstruments.financialInstruments.fields.monthlyTradeAmount.placeholder`
            )}
          />
          <Field.Price
            fullWidth
            showRequiredMark
            label={t(
              `client.legal.targetedFinancialInstruments.financialInstruments.fields.yearlyTradeAmount.label`
            )}
            name={`targetedFinancialInstruments.financialInstruments.${type}.yearlyTradeAmount`}
            placeholder={t(
              `client.legal.targetedFinancialInstruments.financialInstruments.fields.yearlyTradeAmount.placeholder`
            )}
          />
        </GridFields>
      </HiddenBoxStyled>
    </>
  );
};

export const FinancialInstrumentsFields = () => (
  <>
    <Section type="stocks" />
    <Section type="bonds" />
    <Section type="mutualFunds" />
    <Section type="derivatives" />
    <Section type="structuredProducts" />
    <Section type="otherFinancialInstruments" />
  </>
);
